import type { ReactNode } from 'react';
import { Button, Disclosure, Heading } from 'react-aria-components';
import Chevron from '@/assets/icons/ChevronDown.svg';
import { useDataLayer } from '@/hooks/useDataLayer';
import * as Styled from './Accordion.styled';

interface AccordionProps {
  children: ReactNode;
  headingLevel: number;
  isDefaultExpanded?: boolean;
  isFullWidth?: boolean;
  previewText?: string;
  triggerText: string;
}

export const Accordion = ({
  children,
  headingLevel,
  isDefaultExpanded = false,
  isFullWidth = false,
  previewText,
  triggerText,
}: AccordionProps) => {
  const { uiExpand } = useDataLayer();

  return (
    <Disclosure
      defaultExpanded={isDefaultExpanded}
      onExpandedChange={expanded =>
        uiExpand('accordion', triggerText, expanded ? 'expand' : 'collapse')
      }
      {...(isFullWidth ? { className: 'full-width' } : {})}
    >
      <Styled.HeadingWrapper>
        <Heading level={headingLevel}>
          <Button slot="trigger">
            {triggerText} <Chevron />
          </Button>
        </Heading>
        {previewText ? <Styled.Preview>{previewText}</Styled.Preview> : null}
      </Styled.HeadingWrapper>
      <Styled.Panel>{children}</Styled.Panel>
    </Disclosure>
  );
};
